module.exports = __webpack_public_path__ + "img/bg_comm_png2.e279a833.png";